// EarlyAccessList.js
import React, { useEffect, useState } from 'react';
import { Table, Spin } from 'antd';
import moment from 'moment';
import ProjectServices from '../../../../services/projectServices';

const EarlyAccessList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ProjectServices.getEarlyAccessData();
        setData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Define the columns for the Ant Design Table
  const columns = [
    {
      title: 'Full Name',
      dataIndex: 'full_name',
      key: 'full_name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Company Name',
      dataIndex: 'company_name',
      key: 'company_name',
    },
    {
      title: 'Submitted At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), // Format the date
    },
  ];

  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;
  }

  return (
    <div style={{ padding: '20px' }}>
      <Table
        dataSource={data}
        columns={columns}
        rowKey={(record) => record.email}
        pagination={{ pageSize: 5 }}
      />
    </div>
  );
};

export default EarlyAccessList;
